const countryCodes = [
  { code: "91", country: "India", flag: "🇮🇳", maxDigits: 10 },
  { code: "1", country: "United States", flag: "🇺🇸", maxDigits: 10 },
  { code: "44", country: "United Kingdom", flag: "🇬🇧", maxDigits: 10 },
  { code: "971", country: "UAE", flag: "🇦🇪", maxDigits: 9 },
  { code: "1", country: "Canada", flag: "🇨🇦", maxDigits: 10 },
  { code: "61", country: "Australia", flag: "🇦🇺", maxDigits: 9 },
  { code: "966", country: "Saudi Arabia", flag: "🇸🇦", maxDigits: 9 },
  { code: "65", country: "Singapore", flag: "🇸🇬", maxDigits: 8 },
  { code: "60", country: "Malaysia", flag: "🇲🇾", maxDigits: 10 },
  { code: "974", country: "Qatar", flag: "🇶🇦", maxDigits: 8 },
  { code: "968", country: "Oman", flag: "🇴🇲", maxDigits: 8 },
  { code: "973", country: "Bahrain", flag: "🇧🇭", maxDigits: 8 },
  { code: "965", country: "Kuwait", flag: "🇰🇼", maxDigits: 8 },
  { code: "64", country: "New Zealand", flag: "🇳🇿", maxDigits: 10 },
  { code: "49", country: "Germany", flag: "🇩🇪", maxDigits: 11 },
  { code: "33", country: "France", flag: "🇫🇷", maxDigits: 9 },
  { code: "353", country: "Ireland", flag: "🇮🇪", maxDigits: 9 },
  { code: "39", country: "Italy", flag: "🇮🇹", maxDigits: 10 },
  { code: "34", country: "Spain", flag: "🇪🇸", maxDigits: 9 },
  { code: "31", country: "Netherlands", flag: "🇳🇱", maxDigits: 9 },
  { code: "46", country: "Sweden", flag: "🇸🇪", maxDigits: 10 },
  { code: "47", country: "Norway", flag: "🇳🇴", maxDigits: 8 },
  { code: "45", country: "Denmark", flag: "🇩🇰", maxDigits: 8 },
  { code: "41", country: "Switzerland", flag: "🇨🇭", maxDigits: 9 },
  { code: "43", country: "Austria", flag: "🇦🇹", maxDigits: 11 },
  { code: "32", country: "Belgium", flag: "🇧🇪", maxDigits: 9 },
  { code: "48", country: "Poland", flag: "🇵🇱", maxDigits: 9 },
  { code: "351", country: "Portugal", flag: "🇵🇹", maxDigits: 9 },
  { code: "30", country: "Greece", flag: "🇬🇷", maxDigits: 10 },
  { code: "358", country: "Finland", flag: "🇫🇮", maxDigits: 10 },
  { code: "420", country: "Czech Republic", flag: "🇨🇿", maxDigits: 9 },
  { code: "36", country: "Hungary", flag: "🇭🇺", maxDigits: 9 },
  { code: "40", country: "Romania", flag: "🇷🇴", maxDigits: 10 },
  { code: "7", country: "Russia", flag: "🇷🇺", maxDigits: 10 },
  { code: "380", country: "Ukraine", flag: "🇺🇦", maxDigits: 9 },
  { code: "90", country: "Turkey", flag: "🇹🇷", maxDigits: 10 },
  { code: "27", country: "South Africa", flag: "🇿🇦", maxDigits: 9 },
  { code: "234", country: "Nigeria", flag: "🇳🇬", maxDigits: 10 },
  { code: "254", country: "Kenya", flag: "🇰🇪", maxDigits: 10 },
  { code: "20", country: "Egypt", flag: "🇪🇬", maxDigits: 10 },
  { code: "212", country: "Morocco", flag: "🇲🇦", maxDigits: 9 },
  { code: "233", country: "Ghana", flag: "🇬🇭", maxDigits: 9 },
  { code: "255", country: "Tanzania", flag: "🇹🇿", maxDigits: 9 },
  { code: "256", country: "Uganda", flag: "🇺🇬", maxDigits: 9 },
  { code: "251", country: "Ethiopia", flag: "🇪🇹", maxDigits: 9 },
  { code: "92", country: "Pakistan", flag: "🇵🇰", maxDigits: 10 },
  { code: "880", country: "Bangladesh", flag: "🇧🇩", maxDigits: 10 },
  { code: "94", country: "Sri Lanka", flag: "🇱🇰", maxDigits: 9 },
  { code: "977", country: "Nepal", flag: "🇳🇵", maxDigits: 10 },
  { code: "95", country: "Myanmar", flag: "🇲🇲", maxDigits: 9 },
  { code: "66", country: "Thailand", flag: "🇹🇭", maxDigits: 9 },
  { code: "84", country: "Vietnam", flag: "🇻🇳", maxDigits: 10 },
  { code: "62", country: "Indonesia", flag: "🇮🇩", maxDigits: 12 },
  { code: "63", country: "Philippines", flag: "🇵🇭", maxDigits: 10 },
  { code: "81", country: "Japan", flag: "🇯🇵", maxDigits: 10 },
  { code: "82", country: "South Korea", flag: "🇰🇷", maxDigits: 11 },
  { code: "86", country: "China", flag: "🇨🇳", maxDigits: 11 },
  { code: "852", country: "Hong Kong", flag: "🇭🇰", maxDigits: 8 },
  { code: "886", country: "Taiwan", flag: "🇹🇼", maxDigits: 9 },
  { code: "972", country: "Israel", flag: "🇮🇱", maxDigits: 9 },
  { code: "962", country: "Jordan", flag: "🇯🇴", maxDigits: 9 },
  { code: "961", country: "Lebanon", flag: "🇱🇧", maxDigits: 8 },
  { code: "964", country: "Iraq", flag: "🇮🇶", maxDigits: 10 },
  { code: "98", country: "Iran", flag: "🇮🇷", maxDigits: 10 },
  { code: "93", country: "Afghanistan", flag: "🇦🇫", maxDigits: 9 },
  { code: "52", country: "Mexico", flag: "🇲🇽", maxDigits: 10 },
  { code: "55", country: "Brazil", flag: "🇧🇷", maxDigits: 11 },
  { code: "54", country: "Argentina", flag: "🇦🇷", maxDigits: 10 },
  { code: "57", country: "Colombia", flag: "🇨🇴", maxDigits: 10 },
  { code: "56", country: "Chile", flag: "🇨🇱", maxDigits: 9 },
  { code: "51", country: "Peru", flag: "🇵🇪", maxDigits: 9 },
  { code: "58", country: "Venezuela", flag: "🇻🇪", maxDigits: 10 },
  { code: "506", country: "Costa Rica", flag: "🇨🇷", maxDigits: 8 },
  { code: "507", country: "Panama", flag: "🇵🇦", maxDigits: 8 },
  { code: "960", country: "Maldives", flag: "🇲🇻", maxDigits: 7 },
  { code: "975", country: "Bhutan", flag: "🇧🇹", maxDigits: 8 },
  { code: "855", country: "Cambodia", flag: "🇰🇭", maxDigits: 9 },
  { code: "856", country: "Laos", flag: "🇱🇦", maxDigits: 10 },
  { code: "976", country: "Mongolia", flag: "🇲🇳", maxDigits: 8 },
  { code: "998", country: "Uzbekistan", flag: "🇺🇿", maxDigits: 9 },
  { code: "7", country: "Kazakhstan", flag: "🇰🇿", maxDigits: 10 },
  { code: "994", country: "Azerbaijan", flag: "🇦🇿", maxDigits: 9 },
  { code: "374", country: "Armenia", flag: "🇦🇲", maxDigits: 8 },
  { code: "995", country: "Georgia", flag: "🇬🇪", maxDigits: 9 },
  { code: "996", country: "Kyrgyzstan", flag: "🇰🇬", maxDigits: 9 },
  { code: "992", country: "Tajikistan", flag: "🇹🇯", maxDigits: 9 },
  { code: "993", country: "Turkmenistan", flag: "🇹🇲", maxDigits: 8 },
  { code: "250", country: "Rwanda", flag: "🇷🇼", maxDigits: 9 },
  { code: "260", country: "Zambia", flag: "🇿🇲", maxDigits: 9 },
  { code: "263", country: "Zimbabwe", flag: "🇿🇼", maxDigits: 9 },
  { code: "249", country: "Sudan", flag: "🇸🇩", maxDigits: 9 },
  { code: "218", country: "Libya", flag: "🇱🇾", maxDigits: 9 },
  { code: "216", country: "Tunisia", flag: "🇹🇳", maxDigits: 8 },
  { code: "213", country: "Algeria", flag: "🇩🇿", maxDigits: 9 },
  { code: "679", country: "Fiji", flag: "🇫🇯", maxDigits: 7 },
];

export default countryCodes;
